import LanguageDropdown from "components/Language/LanguageDropdown"
import React, { Component,useEffect } from "react"
import { Link, withRouter } from "react-router-dom"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea, Image} from "semantic-ui-react"
import {
	Card,
	Col,
	FormField,
	FormInput,
	Row, Container
  } from "elemental-react16"
import queryString from "qs"
import shop from "shop/shop"
import FormCMS from "components/Form/FormCMS"
import WordPressContainer from "WordPressContainer"
import languageStore from "stores/languageStore"

@withRouter
export default class NewCustomerContactPage extends Component {

	state = {
			hp_website: "",
			activeStep: 0,
			form1Disabled: false,
			form2Disabled: true,
			form3Disabled: true,
			form4Disabled: true,
			form5Disabled: true,
			form1Check: false,
			form2Check: false,
			form4Check: false,
			newcust: {
				firm: {
					name: "",
					customernumber: "",
					uidnr: "",
					glnnr: "",
					legalForm: "",
					taxNumber: "",
					branche: "",
				},
				person: {
					salutation: "",
					firstname: "",
					lastname: "",
					position: "",
				},
				address: {
					street: "",
					streetnumber: "",
					addition: "",
					postcode: "",
					city: "",
					country: "",
					deliverstreet: "",
					deliverstreetnumber: "",
					deliveraddition: "",
					deliverpostcode: "",
					delivercity: "",
					delivercountry: ""
				},
			contact: {
				customernumber: "",
				content: "",
				locale: "de",
				email: "",
				nachname: "",
				subject: "Kontaktdaten ändern",
				vorname: "",
			},
				locale: ""
			}
		}


	componentDidMount() {
		this._formLoadedAt = Date.now();
	}

	handleHoneypotChange = (event) => {
		this.setState({ hp_website: event.target.value });
	};

	handleSendCustReg = async (newCustomer, closeModal, newsletter) =>{
		if (this.state.hp_website) {
			// Honeypot-Feld wurde ausgefüllt -> vermutlich ein Bot, Absenden stillschweigend ignorieren
			return;
		}
		if (Date.now() - (this._formLoadedAt || 0) < 2500) {
			// Formular wurde zu schnell abgeschickt -> vermutlich ein Bot
			return;
		}
		console.log("contact: ", this.state.newcust, closeModal)
		if(closeModal){
			await this.handleSetModalConfig()
		}
		const { currentLanguage } = languageStore
		newCustomer.locale = currentLanguage
		if(newsletter){
			await this.setState(prevState => ({
				newcust: {
					...prevState.newcust,
					contact: {
						...prevState.newcust.contact,
						subject: "Newsletter Anmeldung",
						vorname: " ",
						customernumber: shop.session && shop.session.value ? shop.session.value.map_id : " ",
						content: "Newsletter Anmeldung"
					}
				}
			}));
		}
		if(!closeModal){
			await this.setState(prevState => ({
				newcust: {
					...prevState.newcust,
					contact: {
						...prevState.newcust.contact,
						customernumber: shop.session && shop.session.value ? shop.session.value.map_id : " "
					}
				}
			}));
		}
		if(this.state.newcust.contact.customernumber == "" || this.state.newcust.contact.email == "" || this.state.newcust.contact.content == "" || this.state.newcust.contact.vorname == "" || this.state.newcust.contact.nachname == "" || this.state.newcust.contact.subject == ""){
			shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
			console.log("contact: ", this.state.newcust, closeModal)
			return
		}

		try {
		await shop.fetch( `/shop/rest/service/request?id=${newsletter ? "customer_contact" : "customer_contact"}`, {
			method: "POST",
			body: JSON.stringify( this.state.newcust.contact ),
		} )
		shop.toast( "Kontaktanfrage erfolgreich verschickt!" )
		console.log("newcust: ", this.state.newcust)
		const delay = ms => new Promise(
			resolve => setTimeout(resolve, ms)
		  );
		if(closeModal){
			this.props.onCloseModal()
		}
		//await delay(2000);
		//this.props.history.push("/home");
		}
		catch (err) {
		console.log( err )
		shop.toast( err )
		}
	}

	handleSetModalConfig = async () => {
		if(this.props.closeModal && this.state.newcust.contact.content !== " "){
			this.setState(prevState => ({
				newcust: {
					...prevState.newcust,
					contact: {
						...prevState.newcust.contact,
						content: " "
					}
				}
			}));
		}
		if(this.props.closeModal && this.state.newcust.contact.subject == ""){
			this.setState(prevState => ({
				newcust: {
					...prevState.newcust,
					contact: {
						...prevState.newcust.contact,
						subject: "Anfrage senden"
					}
				}
			}));
		}
	}
	
	render() {
		const countryOptions = [
			{ key: 'de', value: 'de', flag: 'de', text: 'Deutschland' },
			{ key: 'x', value: 'x', flag: 'x', text: 'Andere' },
		  ]
		  const { currentLanguage } = languageStore
		  let genderOptions =[ ]
		  if(currentLanguage == 'fr'){
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Monsieur' },
				{ key: 'female', value: 'Frau', text: 'Madame' },
			]
		  }
		  else{
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Herr' },
				{ key: 'female', value: 'Frau', text: 'Frau' },
				{ key: 'diverse', value: 'Divers', text: 'Divers' },
			]
		  }

		  let referefenceOptions = [ ]
		 if(currentLanguage == 'en'){
			referefenceOptions = [
				{ key: 'male', value: 'Kontaktdaten ändern', text: 'Change contact details' },
				{ key: 'female', value: 'Preisanfrage', text: 'Price request' },
				{ key: 'female', value: 'Bitte um Kontaktaufnahme', text: 'Request contact' },
				{ key: 'female', value: 'Bitte um technische Unterstützung', text: 'Request for technical support' },
				{ key: 'diverse', value: 'Sonstiges', text: 'Miscellaneous' },
			]
		  }
		  else{
			if (!this.props.closeModal) {
				referefenceOptions = [
					{ key: 'male', value: 'Kontaktdaten ändern', text: 'Kontaktdaten ändern' },
					{ key: 'female', value: 'Preisanfrage', text: 'Preisanfrage' },
					{ key: 'female', value: 'Bitte um Kontaktaufnahme', text: 'Bitte um Kontaktaufnahme' },
					{ key: 'female', value: 'Bitte um technische Unterstützung', text: 'Bitte um technische Unterstützung' },
					{ key: 'diverse', value: 'Sonstiges', text: 'Sonstiges' },
					
				]
			}
			else{
				referefenceOptions = [
					{ key: 'diverse', value: 'Anfrage senden', text: 'Anfrage senden' }
					
				]
			}
		  }


		  const handleChange = (event) => {
			console.log("CHANGE: ", event.target)
			let tempname = event.target.name
			let tempname2 = event.target.className
			let tempvalue = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust[tempname][tempname2] = tempvalue;       
				return { newcust }; 
			  })
		  };  
		  const handleDropDownChange = (event, {value}) => {
			let tempvalue = value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust.contact.subject = tempvalue;
				return { newcust }; 
			  })
		  }; 
		
		 const handleCommentChange = ( event ) => {
			console.log("VALUE:",event.target)
			let content = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust.contact.content = content;       
				return { newcust }; 
			  })
		  }
		const { activeStep } = this.state 
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		const { overlay } = query
		const { history, newsletter } = this.props

		console.log("this.props: ", this.props)
		return (
			<div className="pt3">
				<div style={{ position: "absolute", left: "-9999px", top: "-9999px", width: 0, height: 0, overflow: "hidden" }} aria-hidden="true">
					<label htmlFor="website">Website</label>
					<input
						type="text"
						id="website"
						name="website"
						tabIndex="-1"
						autoComplete="off"
						value={this.state.hp_website}
						onChange={this.handleHoneypotChange}
					/>
				</div>

				<p className="f2 fw6 pt3 bt bw2 w-40">{translate("Kontaktformular")} </p>
				<p className="f5 fw4 pb3">{translate("Kontaktieren Sie uns schnell und unkompliziert über das Formular.")} </p>
				{/*<div className="pa3">
					<div className="fr"> <LanguageDropdown/></div>
					<Button as={Link} to="/login"><Icon name="chevron left"/>{translate( "back to login" )}</Button>
				</div>*/}
				{!newsletter && <Form>
					<div style={{minHeight: "300px", display: "flex", flexDirection: "column", justifyContent: "center"}}>
						{this.props.closeModal && <Form.Group  className="w-100 pt2 pb2" widths="equal" style={{alignItems: "center", display: "flex"}}>
							<Form.Input required label={translate("Kundennummer")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" fluid value={this.state.newcust.contact.customernumber} onChange={handleChange} className="customernumber" name="contact" label="Kundennummer:" placeholder={translate("Kundennummer")} style={{verticalAlign: "middle"}} />
							</Form.Input>
						</Form.Group>}
						<Form.Group  className="w-100 pt2 pb2" widths="equal" style={{alignItems: "center", display: "flex"}}>
							<Form.Input required label={translate("Vorname")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" fluid value={this.state.newcust.person.vorname} onChange={handleChange} className="vorname" test="firstname" name="contact" label="Vorname:" placeholder={translate("Vorname")} style={{verticalAlign: "middle"}} />
							</Form.Input>
							<Form.Input required label={translate("Nachname")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" fluid value={this.state.newcust.person.nachname} onChange={handleChange} className="nachname" name="contact" label="Nachname:" placeholder={translate("Nachname")} style={{verticalAlign: "middle"}} />
							</Form.Input>
						</Form.Group>
						<Form.Group className="w-100 pt2 pb2"  widths="equal" style={{alignItems: "center", display: "flex"}}>
							<Form.Input  required className="default" label={translate("E-Mail")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" style={{backgroundColor: "#ffffff", verticalAlign: "middle"}} value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
							</Form.Input>
							<Form.Input required label={translate("Telefon")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" value={this.state.newcust.contact.phone} onChange={handleChange} required fluid className="phone" name="contact" label="Telefon:" placeholder={translate("Telefon")} style={{verticalAlign: "middle"}} />
							</Form.Input>
						</Form.Group>
						{!this.props.closeModal && <Form.Field className="w-100 pt2 pb2" required style={{backgroundColor: "#ffffff", height: "50px", display: "flex", flexDirection: "column", justifyContent: "center"}}>
							<label>{translate("Betreff")}</label>
							<Dropdown
								id="default"
								fluid
								floating
								style={{backgroundColor: "#ffffff", height: "50px", minHeight: "50px", display: "flex", alignItems: "center"}}
								value={this.state.newcust.person.reference}
								onChange={handleDropDownChange}
								clearable
								label="Land:"
								className="reference"
								name="contact"
								required
								selection  defaultValue={ referefenceOptions[0].value}
								options={referefenceOptions}
								placeholder={translate("Betreff")}
							/>
						</Form.Field>}
						{!this.props.closeModal && <FormField  className="w-100 pt2 pb2" label={<label className="fw6 f5 black-90">{translate("Ihre Mitteilung an uns")}</label>} htmlFor="supported-controls-input" style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
							<FormInput placeholder={translate("commentPlaceholder")} className="deliveryComment" value={this.state.newcust.contact.comment} onChange={handleCommentChange} multiline style={{verticalAlign: "middle"}} />
						</FormField>}
						<Checkbox className="pt3 pb3"  label={<label className="fw6 f7"><p className="f7 fw7">{translate(`Ja, ich habe die Datenschutzerklärung zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden.`)}</p></label>} />
						{<div className="pb5"><Button style={{
								borderRadius: "35px", 
								height: "50px", 
								width: "250px", 
								color: "white",
								transition: "all 0.3s ease",
								padding: "10px 20px 10px 20px",
								
							}}  onClick={() => this.handleSendCustReg(this.state.newcust, this.props.closeModal)} primary>
						{this.props.closeModal ? translate("Zugang anfordern") : translate("Anfrage abschicken")}
						<i className="icon-angle-right"/>
						</Button></div>}
					</div>
				</Form>}
				{newsletter && <Form>
					<div style={{minHeight: "300px", display: "flex", flexDirection: "column", justifyContent: "center", paddingTop: "70px"}}>

						<Form.Group className="w-100 pt2 pb2"  widths="equal" style={{alignItems: "center", display: "flex"}}>
							<Form.Input  required className="default" label={translate("E-Mail")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" style={{backgroundColor: "#ffffff", verticalAlign: "middle"}} value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
							</Form.Input>
							<Form.Input required label={translate("Name")} style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
								<input id="default" fluid value={this.state.newcust.person.nachname} onChange={handleChange} className="nachname" name="contact" label="Nachname:" placeholder={translate("Name")} style={{verticalAlign: "middle"}} />
							</Form.Input>
						</Form.Group>
						{/*<div className="fw6 pt3">{translate("Einwilligung zum Newsletter-Versand")} </div>
						<Checkbox className="pt3 pb3"  label={<label className="fw6 f7"><p className="f7 fw7">{translate(`Ich möchte den Newsletter von Trendsoft erhalten und willige in die Verarbeitung meiner Daten gemäß der Datenschutzerklärung ein.`)}</p></label>} />
						 */}{<div className="pb5 pt3"><Button style={{
								borderRadius: "35px", 
								height: "50px", 
								width: "300px", 
								color: "white",
								transition: "all 0.3s ease",
								padding: "10px 20px 10px 20px",

							}}  onClick={() => this.handleSendCustReg(this.state.newcust, this.props.closeModal, newsletter)} primary>
						{translate("Newsletter Anmeldung absenden")}
						<i className="icon-angle-right"/>
						</Button></div>}
					</div>
				</Form>}
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/theme/trendimport.test/pages/NewCustomerContactPage.js